import React from 'react';

/**
 * Compact read-only badge that surfaces the `is_credit_eligible` flag in the
 * Agent / Corporate / OTA view modals. Green when the source can bypass the
 * advance requirement, neutral grey when it follows the standard policy.
 *
 * Renders nothing when `eligible` is undefined (fields not loaded yet).
 */
interface CreditEligiblePillProps {
  eligible?: boolean | null;
}

const CreditEligiblePill: React.FC<CreditEligiblePillProps> = ({ eligible }) => {
  if (eligible === undefined || eligible === null) return null;

  const isYes = !!eligible;
  return (
    <span
      title={isYes
        ? 'This party is credit-eligible — bookings against it skip the advance requirement and settle later under the credit_days terms.'
        : 'Standard policy applies — bookings against this party require an advance per the configured policy.'}
      style={{
        fontSize: '0.7rem',
        fontWeight: 600,
        padding: '0.125rem 0.5rem',
        borderRadius: '0.25rem',
        background: isYes ? '#dcfce7' : 'var(--bg-secondary)',
        color: isYes ? '#166534' : 'var(--text-muted)',
        border: `1px solid ${isYes ? '#86efac' : 'var(--border-color)'}`,
        whiteSpace: 'nowrap',
      }}
    >
      {isYes ? '✓ Credit Eligible' : 'Standard'}
    </span>
  );
};

export default CreditEligiblePill;
